import { Link } from 'react-router-dom';
import VerdictBadge from '@/components/base/VerdictBadge';
import { getExposeById } from '@/lib/content';
import { featuredId } from '@/mocks/exposes';
import { site } from '@/mocks/site';
import { credibilityBarClass, credibilityLabel } from '@/lib/verdict';

export default function Hero() {
  const featured = getExposeById(featuredId)!;

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="container-page py-8 md:py-12">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-300 pb-4">
          <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">热料核实情报站</p>
          <p className="text-xs text-foreground-500">{site.issue} · 每日更新核实记录</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <h1 className="font-heading text-3xl leading-tight font-bold text-foreground-950 md:text-[44px] md:leading-[1.15]">
              <span className="text-primary-600">{site.name}</span>：一条料的真假，
              <br className="hidden sm:block" />
              我们替你核到底。
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
              {site.intro}
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/ranking"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-eye-line"></i>
                </span>
                浏览热料榜单
              </Link>
              <Link
                to="/debunk"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-cross-line"></i>
                </span>
                查看辟谣专题
              </Link>
            </div>

            <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
              {[
                { value: '1,286', label: '累计核实' },
                { value: '318', label: '实锤成立' },
                { value: '412', label: '已辟谣' },
                { value: '26', label: '仍在核实' },
              ].map((s) => (
                <div key={s.label} className="border-l-2 border-primary-300 pl-3">
                  <dt className="font-heading text-2xl font-bold text-foreground-950">{s.value}</dt>
                  <dd className="mt-0.5 text-xs text-foreground-500">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <article className="overflow-hidden rounded-xl border border-background-300 bg-background-50">
              <div className="flex items-center justify-between px-5 pt-5">
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-pushpin-2-line"></i>
                  </span>
                  本期重点核实
                </span>
                <VerdictBadge verdict={featured.verdict} />
              </div>
              <Link to={`/expose/${featured.id}`} className="mt-4 block px-5">
                <div className="w-full aspect-[16/10] overflow-hidden rounded-lg bg-background-100">
                  <img
                    src={featured.cover}
                    alt={`${featured.title} 核实配图`}
                    title={`${featured.title} - 看料爆料核实`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </Link>
              <div className="p-5">
                <h2 className="font-heading text-lg font-semibold leading-snug text-foreground-950">
                  <Link to={`/expose/${featured.id}`} className="hover:text-primary-600 transition-colors">
                    {featured.title}
                  </Link>
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{featured.summary}</p>

                <div className="mt-4">
                  <div className="mb-1.5 flex items-center justify-between text-xs text-foreground-500">
                    <span>{credibilityLabel(featured.credibility)}</span>
                    <span className="font-semibold text-foreground-800">可信度 {featured.credibility}</span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${credibilityBarClass(featured.credibility)}`}
                      style={{ width: `${featured.credibility}%` }}
                    ></div>
                  </div>
                </div>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span>{featured.timeline.length} 个核实节点</span>
                  <span>{featured.updatedAt} 更新</span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}